<template>
  <el-upload
    ref="splitUploads"
    :class="className"
    :auto-upload="true"
    :data="data"
    :show-file-list="showfilelist"
    :http-request="checkedFile"
    :before-remove="removeFile"
    :accept="accept"
    :limit="limit"
    :on-exceed="onExceed"
    :before-upload="beforeUpload"
    :on-error="onError"
    :on-progress="onProgress"
    :on-success="onSuccess"
    action="/">
    <img v-if="imageUrl" :src="imageUrl" class="avatar">
    <i style="line-height: 110px;" v-else :class="!exClass?'el-icon-upload':exClass">{{exText}}</i>
    <el-progress type="circle" v-show="showPross && Start" :width="88"
                 :percentage="percentage"></el-progress>
  </el-upload>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'SplitUpload',
    componentName: 'SplitUpload',
    provide() {
      return {
        SplitUpload: this
      };
    },
    props: {
      headers: Object,
      data: Object,
      stype: String,
      showfilelist: Boolean,
      limit: Number,
      onExceed: Function,
      beforeUpload: Function,
      onProgress: Function,
      onSuccess: Function,
      onError: Function,
      className: String,
      exText: String,
      exClass: String,
      accept: String,
      showPross: Boolean,
      mustData: Boolean,
      uploadHost: String,
      validateHost: String,
      SourceHost: String,
      deUrl: {type: String, default: ""}
    },
    data() {
      return {
        Start: false,
        percentage: 0,
        imageUrl: "",
        maxSize: 5 * 1024 * 1024 * 1024, // 上传最大文件限制
        multiUploadSize: 10 * 1024 * 1024, // 大于这个大小的文件使用分块上传(后端可以支持断点续传)
        eachSize: 10 * 1024 * 1024, // 每块文件大小
        requestCancelQueue: [], // 请求方法队列（调用取消上传
      }
    },
    mounted() {
      this.imageUrl = this.deUrl;
    },
    methods: {
      async checkedFile(options) {
        const {maxSize, multiUploadSize, mustData, getSize, splitUpload, singleUpload} = this;
        const {file, onProgress, onSuccess, onError} = options;
        if (file.size > maxSize) {
          return this.$message({
            message: `您选择的文件大于${getSize(maxSize)}`,
            type: 'error'
          })
        }
        if (mustData) {
          if (!this.data) {
            return this.$message({
              message: `所需参数错误，请刷新页面重试！`,
              type: 'error'
            });
          }
          if (this.data) {
            let ismust = false;
            for (let key in this.data) {
              if (this.data[key]) {
                ismust = true;
              }
            }
            if (!ismust) {
              return this.$message({
                message: `所需参数错误，请刷新页面重试！`,
                type: 'error'
              });
            }
          }
        }
        const uploadFunc = file.size > multiUploadSize ? splitUpload : singleUpload;
        try {
          if (this.showPross) {
            this.Start = true;
          }
          let res = await uploadFunc(file, onProgress);
          this.$message({
            message: '上传成功',
            type: 'success'
          });
          if (this.Start) {
            this.Start = false;
            this.percentage = 0;
          }
          if (res.code === 1) {
            this.imageUrl = this.SourceHost + res.data;
            onSuccess(res, this.stype, file);
          } else {
            this.$message({
              message: `上传失败${res.error}`,
              type: 'error'
            });
          }
        } catch (e) {
          // console.error(e)
          this.$message({
            message: e.message,
            type: 'error'
          });
          if (this.Start) {
            this.Start = false;
            this.percentage = 0;
          }
          onError(e, this.stype)
        }
        const prom = new Promise((resolve, reject) => {
        });
        prom.abort = () => {
        };
        return prom
      },
      setSuccess() {
        this.imageUrl = "../../../../static/success.png";
      },
      // 格式化文件大小显示文字
      getSize(size) {
        return size > 1024
          ? size / 1024 > 1024
            ? size / (1024 * 1024) > 1024
              ? (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
              : (size / (1024 * 1024)).toFixed(2) + 'MB'
            : (size / 1024).toFixed(2) + 'KB'
          : (size).toFixed(2) + 'B'
      },
      // 单文件直接上传
      singleUpload(file, onProgress) {
        return this.postFile({file, uid: file.uid, fileName: file.name}, onProgress)
      },
      // 大文件分块上传
      splitUpload(file, onProgress) {
        return new Promise(async (resolve, reject) => {
          try {
            const {eachSize} = this;
            const chunks = Math.ceil(file.size / eachSize);
            const fileChunks = await this.splitFile(file, eachSize, chunks);
            let currentChunk = 0;

            for (let i = 0; i < fileChunks.length; i++) {
              // 服务端检测已经上传到第currentChunk块了，那就直接跳到第currentChunk块，实现断点续传
              //console.log(currentChunk, i)
              if (Number(currentChunk) === i) {
                // 每块上传完后则返回需要提交的下一块的index
                currentChunk = await this.postFile({
                  chunked: true,
                  chunk: i,
                  chunks,
                  eachSize,
                  fileName: file.name,
                  fullSize: file.size,
                  uid: file.uid,
                  file: fileChunks[i]
                }, onProgress)
              }
            }
            const isValidate = await this.validateFile({
              chunks: fileChunks.length,
              fileName: file.name,
              fullSize: file.size,
              uid: file.uid
            });
            if (!isValidate) {
              throw new Error('文件校验异常')
            }
            resolve(isValidate)
          } catch (e) {
            reject(e)
          }
        })
      },
      // 文件分块,利用Array.prototype.slice方法
      splitFile(file, eachSize, chunks) {
        return new Promise((resolve, reject) => {
          try {
            setTimeout(() => {
              const fileChunk = [];
              for (let chunk = 0; chunks > 0; chunks--) {
                fileChunk.push(file.slice(chunk, chunk + eachSize));
                chunk += eachSize
              }

              resolve(fileChunk)
            }, 0)
          } catch (e) {
            //console.error(e)
            reject(new Error('文件切块发生错误'))
          }
        })
      },
      removeFile(file) {
        this.requestCancelQueue[file.uid]();
        delete this.requestCancelQueue[file.uid];
        return true
      },
      // 提交文件方法,将参数转换为FormData, 然后通过axios发起请求
      postFile(param, onProgress) {
        const formData = new FormData();
        for (let p in param) {
          //console.log( p+">"+param[p]);
          formData.append(p, param[p]);
        }
        const {requestCancelQueue} = this;
        const config = {
          headers: this.headers,
          cancelToken: new axios.CancelToken(function executor(cancel) {
            if (requestCancelQueue[param.uid]) {
              requestCancelQueue[param.uid]();
              delete requestCancelQueue[param.uid]
            }
            requestCancelQueue[param.uid] = cancel
          }),
          onUploadProgress: e => {
            if (param.chunked) {
              e.percent = Number(((((param.chunk * (param.eachSize - 1)) + (e.loaded)) / param.fullSize) * 100).toFixed(2))
            } else {
              e.percent = Number(((e.loaded / e.total) * 100).toFixed(2))
            }
            this.percentage = e.percent;
            onProgress(e, this.stype);
          }
        };
        if (this.data) {
          for (let key in this.data) {
            formData.append(key, this.data[key]);
          }
        }
        return axios.post(this.uploadHost, formData, config).then(rs => {
          let res = rs.data;
          if (param.chunked) {
            if (res.code === 1) {
              return res.data;
            } else {
              return "err"
            }
          }
          return res;
        });
      },
      clearFiles() {
        this.$refs.splitUploads.clearFiles();
      },
      // 文件校验方法
      validateFile(file) {
        let config = {
          headers: this.headers
        };
        let parms = {
          file: file,
          data: this.data
        };
        return axios.post(this.validateHost, parms, config).then(rs => rs.data)
      }
    },
    watch: {
      deUrl(nv, ov) {
        if (nv && nv !== "") {
          this.imageUrl = nv;
        }
      }
    }
  }
</script>

<style lang="scss">

  .avatar-uploader {
    position: absolute;
    right: 0;
  }

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    line-height: 110px;
    text-align: center;
  }

  .avatar {
    width: 110px;
    height: 110px;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/components/SplitUpload.vue